export const STICKY_BUTTON_HEIGHT = 74;
